export const pageConfig = {
  // Intro 섹션
  "intro/intro": {
    title: "Introduction",
    description: "저희 샵을 소개합니다",
    section: "intro",
  },
  "intro/shop": {
    title: "Shop",
    description: "미장원 by 태현 이미지",
    section: "intro",
  },
  "intro/location": {
    title: "Location",
    description: "미장원 찾아오시는 길",
    section: "intro",
  },

  // Hair 섹션
  "hair/list": {
    title: "Hair Designer",
    description: "저희 샵의 헤어 디자이너를 소개합니다.",
    section: "hair",
  },
  "hair/trend": {
    title: "Hair Trend",
    description: "최신 헤어 트렌드를 확인해보세요.",
    section: "hair",
  },
  "hair/gallery": {
    title: "Hair Gallery",
    description: "헤어 갤러리",
    section: "hair",
  },

  // MakeUp 섹션
  "makeUp/list": {
    title: "MakeUp Designer",
    description: "저희 샵의 메이크업 디자이너를 소개합니다.",
    section: "makeUp",
  },
  "makeUp/trend": {
    title: "MakeUp Trend",
    description: "최신 메이크업 트렌드를 확인해보세요.",
    section: "makeUp",
  },
  "makeUp/gallery": {
    title: "MakeUp Gallery",
    description: "메이크업 갤러리",
    section: "makeUp",
  },

  // Wedding 섹션
  "wedding/trend": {
    title: "Wedding Trend",
    description: "최신 웨딩 트렌드를 확인해보세요.",
    section: "wedding",
  },
  "wedding/gallery": {
    title: "Wedding Gallery",
    description: "웨딩 갤러리",
    section: "wedding",
  },

  // Star 섹션
  "star/magazine": {
    title: "Star Magazine",
    description: "연예인들의 화보를 확인해보세요.",
    section: "star",
  },
  "star/music": {
    title: "Star Music",
    description: "연예인들의 뮤비, 앨범을 확인해보세요.",
    section: "star",
  },
  "star/advertisement": {
    title: "Star Advertisement",
    description: "연예인들의 광고를 확인해보세요.",
    section: "star",
  },

  // NailArt 섹션
  "nailArt/list": {
    title: "NailArt Designer",
    description: "저희 샵의 네일아트 디자이너를 소개합니다.",
    section: "nailArt",
  },
  "nailArt/trend": {
    title: "NailArt Trend",
    description: "최신 네일아트 트렌드를 확인해보세요.",
    section: "nailArt",
  },
  "nailArt/gallery": {
    title: "NailArt Gallery",
    description: "네일아트 갤러리",
    section: "nailArt",
  },

  // Csc 섹션
  "csc/notice": {
    title: "Notice",
    description: "공지사항을 확인해주세요.",
    section: "csc",
  },
  "csc/recruit": {
    title: "Csc Recruit",
    description: "미장원 by 태현과 함께 할 인재를 모십니다.",
    section: "service",
  },
};
